export const formatPathLabel = (
  path: string,
  prefixToRemove: string,
  separator: string,
): string => {
  let labelPath = path;
  if (labelPath.startsWith(prefixToRemove)) {
    labelPath = labelPath.slice(prefixToRemove.length);
  }

  const parts = labelPath.split(separator);
  if (parts[parts.length - 1] === "isEnabled") {
    parts.pop();
  }

  return parts
    .map((part) =>
      part
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
        .trim(),
    )
    .join(" / ");
};

const escapeQuotes = (str: string) => str.replaceAll("'", "");

export default escapeQuotes;

export const createItemLabel = <T extends Record<string, any>>(item: T): string => {
  if (Object.prototype.hasOwnProperty.call(item, "tag") && item?.name) {
    return `${item?.name} ${item?.tag}`;
  }

  if (Object.prototype.hasOwnProperty.call(item, "type") && item?.name) {
    return [
      item?.name,
      item?.description ? `Description: ${item.description}` : null,
      `Type: ${item?.type}`,
      item?.sku ? `Sku: ${item.sku}` : null,
      `Price: ${item?.unitPrice}`,
    ]
      .filter(Boolean)
      .join(", ");
  }

  if (Object.prototype.hasOwnProperty.call(item, "name") && item?.name) {
    return item.name;
  }

  if (Object.prototype.hasOwnProperty.call(item, "firstName")) {
    return `${item?.firstName} ${item?.lastName} ${item?.jobTitle ? `, ${item?.jobTitle}` : ""}`;
  }

  return "Invalid";
};
